import { render, staticRenderFns } from "./upImg.vue?vue&type=template&id=9a4c0772&"
import script from "./upImg.vue?vue&type=script&lang=js&"
export * from "./upImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports